import React from 'react';
import { useSocket } from '../context/SocketContext';
import { sosAPI } from '../api/api';
import toast from 'react-hot-toast';

export default function SOSBanner() {
  const { sosAlerts, clearSosAlert } = useSocket();

  if (!sosAlerts.length) return null;

  const acknowledge = async (alert) => {
    try {
      await sosAPI.acknowledge(alert.alertId);
      clearSosAlert(alert.alertId);
      toast.success('SOS acknowledged');
    } catch {
      toast.error('Failed to acknowledge');
    }
  };

  return (
    <div className="sos-banner">
      {sosAlerts.slice(0, 3).map((alert, i) => (
        <div key={i} className="sos-alert-card">
          <div className="sos-alert-title">
            <span className="sos-pulse">🚨</span>
            SOS ALERT — {alert.childName}
          </div>
          <div className="sos-alert-info">
            {alert.location?.address || `📍 ${alert.location?.latitude?.toFixed(4)}, ${alert.location?.longitude?.toFixed(4)}`}
            <br />
            {alert.message}
            {alert.keywords?.length > 0 && (
              <><br />🔑 Keywords: {alert.keywords.join(', ')}</>
            )}
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <button className="btn btn-danger btn-sm" onClick={() => acknowledge(alert)}>
              ✓ Acknowledge
            </button>
          </div>
        </div>
      ))}
    </div>
  );
}
